import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import { CircularProgress } from '@material-ui/core';

export default ({ refresh }: { refresh: () => void }) => {
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const uploadFile = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files) return;
    const file = e.target.files[0];
    const formData = new FormData();
    setIsUploading(true);
    formData.append('file', file);
    fetch(`/api/file/${file.name}`, {
      method: 'POST',
      body: formData,
    }).then(() => {
      refresh();
      setIsUploading(false);
    });
    e.target.value = '';
  };

  return (
    <form className="upload-form">
      <input
        accept="application/gzip"
        style={{ display: 'none' }}
        id="contained-button-file"
        type="file"
        onChange={uploadFile}
      />
      <label htmlFor="contained-button-file">
        <Button startIcon={isUploading ? <CircularProgress size={24} /> : undefined} disabled={isUploading} variant="contained" color="primary" component="span">
          {isUploading ? 'Uploading...' : 'Upload'}
        </Button>
      </label>
    </form>
  )
}